module.exports = __webpack_public_path__ + "media/images/file-icons/256/008-archive-e572440435bd210f5c835c6387aa7312.png";